<template>
	<main class="complete">
		<div class="icon_wrapper">
			<img src="@/assets/img/common/exclamation.png" alt="구독 결제 실패 아이콘" loading="lazy" />
			<div class="icon_title">
				<p>결제에 실패했습니다.</p>
				<p>지속적으로 결제가 이루어지지 않는 경우 <br />카카오 상담톡으로 문의하시기 바랍니다.</p>
			</div>
		</div>
		<div class="c_fieldArea">
			<button class="c_button radius-x-small primary-fill save" @click="$router.replace('/payment')">
				다시 결제하기
			</button>
			<button class="c_button radius-x-small mid save" @click="$router.replace('/notice-detail/126')">
				카카오 상담톡 문의 안내
			</button>
		</div>
	</main>
</template>
<script setup lang="ts"></script>
<style lang="scss" scoped>
.complete {
	padding-top: var(--header-height);
	display: flex;
	flex-direction: column;
	gap: var(--space-xx-large);
	max-width: 40rem;
	margin: 0 auto;
	justify-content: center;
	width: 100%;
	img {
		width: 12rem;
	}
	@media screen and (max-width: 1280px) {
		padding: 0rem 2rem 0rem 2rem;
	}
	.icon_wrapper {
		display: flex;
		flex-direction: column;
		align-items: center;
		gap: var(--space-x-large);
		.icon_title {
			font-weight: var(--font-w-semi-bold);
			font-size: var(--space-large);
			line-height: 2.387rem;
			text-align: center;
			p:nth-child(2) {
				margin-top: 0.8rem;
				color: var(--color-base-light);
				font-weight: var(--font-w-light);
				font-size: var(--font-s-regular);
				line-height: 2.3rem;
			}
		}
	}
	.c_fieldArea {
		gap: var(--space-mid);
		button {
			font-weight: var(--font-w-medium);
			font-size: var(--font-s-regular);
			line-height: 2.1rem;
			height: 4.8rem;
		}
	}
}
</style>
